export default "__VITE_ASSET__DhEOLhRe__"